import { render } from "./Login.vue?vue&type=template&id=36e37a09&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=36e37a09&lang=scss&scoped=true"

import exportComponent from "E:\\uni-app项目\\kxsns-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e37a09"]])

export default __exports__